module.exports = __webpack_public_path__ + "img/preview-app-bottomtab.491a23d3.png";